"use strict";

const ScreenSize = angular
    .module("ScreenSize", [])
    .directive("screenSize", ["$window", screenSizeDirective]);

function screenSizeDirective($window) {
    return {
        restrict: "A",
        link: function (scope, element) {
            $window.onresize = function () {
                setSize();
                scope.$apply();
            };
            setSize();

            function setSize() {
                var screenWidth = $window.innerWidth;
                if (screenWidth < 700) {
                    scope.mobile = true;
                } else if (screenWidth >= 700) {
                    scope.mobile = false;
                }
            }
        }
    };
}

export default ScreenSize;
